import React, { useEffect, useContext } from 'react';
import { BrandingContext } from '../contexts/ContractContext';
import { getMetaDataByClient } from '../../App';

export const usePageTitle = (title) => {
    const { clientId } = useContext(BrandingContext);
    useEffect(() => {
        const pageTitle = getMetaDataByClient(clientId, title).title;
        document.title = pageTitle;
    }, []);
    return;
};
